import React, { useEffect, useState } from "react";
import moment from "moment";
import LoadMask from "Utils/LoadMask/LoadMask";
import Alerta from "../../../../../Utils/Alerta/Alerta";
import {
    RenderKilogramo,
    RenderNumberPercentage,
} from "../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../Utils/renderField/nullableValue";
import { CreacionTrasladoAlmacenApi } from "../api/CreacionTrasladoAlmacenApi";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../utility/utils";
import { NotificationManager } from "react-notifications";
import { FiltrosRecepciones } from "./FiltrosRecepciones";
import { useForm } from "react-hook-form";
import { useDebounce } from "../../../../../Utils/Hooks/useDebounce";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
const salidaIcon = require("assets/img/icons/right-arrow-v2.png");

export const Recepciones = (props) => {
    const { almacenId, PedirConfirmacionTraslado, refreshKey } = props;

    const { getMovimientosAlmacen, cargando } = CreacionTrasladoAlmacenApi();

    const { control, watch } = useForm({
        defaultValues: {
            search: "",
            fecha_inicial: moment().startOf("month"),
            fecha_final: moment().endOf("month"),
        },
    });

    const [movimientosAlmacen, setMovimientosAlmacen] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);
    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const GetMovimientosAlmacen = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayEnd(fecha_final);
            }

            const response = await getMovimientosAlmacen(almacenId, params);
            setMovimientosAlmacen(response.results || []);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al cargar recepciones del almacén.",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setMovimientosAlmacen([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        GetMovimientosAlmacen();
    }, [
        almacenId,
        refreshKey,
        paginaSeleccionada,
        debouncedSearch,
        fecha_inicial,
        fecha_final,
    ]);

    return (
        <LoadMask loading={cargando} blur>
            <h5 className="mb-0">Seleccionar recepción</h5>

            <FiltrosRecepciones
                control={control}
                onRefresh={GetMovimientosAlmacen}
                resetPage={() => setPaginaSeleccionada(1)}
                searchPlaceholder="ID Recepción"
            />

            {/* TABLA DE RECEPCIONES */}
            <div className="new-table-wrapper creacion-traslado-almacen__table-wrapper">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>ID RECEPCIÓN</th>
                            <th>FECHA INGRESO</th>
                            <th>KILOS HÚMEDOS</th>
                            <th>DRC LABORATORIO</th>
                            <th>KILOS SECOS LAB</th>
                            <th>DRC LIQUIDACIÓN</th>
                            <th>KILOS SECOS LIQ</th>
                            <th>ACCIONES</th>
                        </tr>
                    </thead>
                    <tbody>
                        {movimientosAlmacen.length === 0 && (
                            <tr>
                                <td className="text-center" colSpan={8}>
                                    No hay recepciones disponibles
                                </td>
                            </tr>
                        )}
                        {movimientosAlmacen.map((item) => {
                            return (
                                <tr key={item.movimiento_id}>
                                    <td className="text-center text-nowrap">
                                        {item.display_id}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        {item.fecha_ingreso
                                            ? moment(item.fecha_ingreso).format(
                                                  "DD/MM/YYYY HH:mm",
                                              )
                                            : ""}
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue value={item.kg_humedos}>
                                            <RenderKilogramo
                                                value={item.kg_humedos}
                                                decimalScale={2}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue value={item.drc_lab}>
                                            <RenderNumberPercentage
                                                value={item.drc_lab}
                                                decimalScale={3}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue
                                            value={item.kg_secos_lab}
                                        >
                                            <RenderKilogramo
                                                value={item.kg_secos_lab}
                                                decimalScale={3}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue value={item.drc_liq}>
                                            <RenderNumberPercentage
                                                value={item.drc_liq}
                                                decimalScale={3}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <NullableValue
                                            value={item.kg_secos_liq}
                                        >
                                            <RenderKilogramo
                                                value={item.kg_secos_liq}
                                                decimalScale={3}
                                            />
                                        </NullableValue>
                                    </td>
                                    <td className="text-center text-nowrap">
                                        <div className="table-actions">
                                            <img
                                                src={salidaIcon}
                                                alt="Trasladar recepción"
                                                className="action_img"
                                                title="Trasladar recepción"
                                                onClick={() =>
                                                    PedirConfirmacionTraslado(
                                                        item,
                                                    )
                                                }
                                            />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <Paginacion
                cantidadResultados={cantidadResultados}
                paginaSeleccionada={paginaSeleccionada}
                setPaginaSeleccionada={setPaginaSeleccionada}
            />
        </LoadMask>
    );
};
